import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BookOpen, CalendarHeart, Instagram, MessageCircle, Music2, ArrowUpRight } from "lucide-react";
import useSettings from "@/hooks/useSettings";
import { IMAGES } from "@/lib/api";

const Item = ({ to, href, icon: Icon, title, sub, primary, testid, i }) => {
  const cls = `group flex items-center gap-4 w-full rounded-2xl px-5 py-4 border ${
    primary ? "btn-terra border-transparent" : "btn-ghost bg-white border-[#E5E1D8] hover:border-[#1E231F]"
  }`;
  const inner = (
    <>
      <span className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${primary ? "bg-white/15" : "bg-[#F9F7F3]"}`}>
        <Icon className="w-4 h-4" />
      </span>
      <span className="flex-1 text-left">
        <span className="block font-semibold">{title}</span>
        {sub && <span className={`block text-xs ${primary ? "text-white/75" : "text-[#5A625C]"}`}>{sub}</span>}
      </span>
      <ArrowUpRight className="w-4 h-4 opacity-60 group-hover:opacity-100" />
    </>
  );
  return (
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15 + i * 0.07, duration: 0.6 }}>
      {to ? <Link to={to} className={cls} data-testid={testid}>{inner}</Link>
          : <a href={href} target="_blank" rel="noreferrer" className={cls} data-testid={testid}>{inner}</a>}
    </motion.div>
  );
};

export default function Links() {
  const s = useSettings();
  const items = [
    { to: "/", icon: BookOpen, title: "Guida gratuita: 7 giorni di ricomposizione", sub: "Senza diete estreme · PDF", primary: true, testid: "links-guide-link" },
    { to: "/prenota", icon: CalendarHeart, title: "Prenota una chiamata conoscitiva", sub: "20 minuti, gratis, senza impegno", testid: "links-call-link" },
    s?.whatsapp_url && { href: s.whatsapp_url, icon: MessageCircle, title: "Scrivimi su WhatsApp", testid: "links-whatsapp-link" },
    s?.instagram_url && { href: s.instagram_url, icon: Instagram, title: "Instagram", testid: "links-instagram-link" },
    s?.tiktok_url && { href: s.tiktok_url, icon: Music2, title: "TikTok", testid: "links-tiktok-link" },
  ].filter(Boolean);

  return (
    <main className="min-h-screen bg-[#F9F7F3] text-[#1E231F] px-5 py-14" data-testid="links-page">
      <div className="max-w-md mx-auto">
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="text-center">
          <img src={IMAGES.portrait} alt="Chiara Piccioni" className="w-24 h-24 rounded-full object-cover object-[50%_25%] mx-auto border-4 border-white" />
          <h1 className="font-display text-4xl mt-5 tracking-tight">Chiara Piccioni</h1>
          <p className="text-[11px] uppercase tracking-[0.25em] font-bold text-[#748E63] mt-2">Fitness coach per donne</p>
          <p className="mt-4 text-[#5A625C] text-[15px] leading-relaxed">
            Ricomposizione corporea senza diete estreme né allenamenti punitivi. Coaching 1:1 online.
          </p>
        </motion.div>
        <div className="mt-10 space-y-3">
          {items.map((it, i) => <Item key={it.testid} {...it} i={i} />)}
        </div>
      </div>
    </main>
  );
}
